const methods = {
    // Consultamos al back las cuentas y productos con descuadres
    async fetchData() {
        this.loading = true;
        try {
            const res = await this.$accountsService.operationsMismatchesProductAccount(
                this.productSelected.key_product, this.accountId);
            this.items = res.data.operations_mismatches && res.data.operations_mismatches.filter(op => op.processed !== true) || [];
        } catch (error) {
            this.$toast.error(`Error`, `No se han podido obtener las operaciones descuadradas.`);
        }
        this.loading = false;
    },

    // Comprobamos si la fila está seleccionada o no para ponerle
    // el color de fondo en verde
    rowClass(row) {
        return row.selected ? 'table-success' : '';
    },

    modalWarning(type, item) {
        this.actionSelected = type;
        this.fusionItemSelected = item.actionData;
        item._origin = 'tab-accounts-details';
        this.$root.$emit('showModalWarningAction', { show: true, type, item });
    },

    fusionBulkActivate(item) {
        this.$root.$emit('checksActivated', { status: true, item });
    }
};

export default methods;
